"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontAssetUrl = exports.getImageAssetUrl = void 0;
var bui_assets_core_1 = require("@bookingcom/bui-assets-core");
Object.defineProperty(exports, "getImageAssetUrl", { enumerable: true, get: function () { return bui_assets_core_1.getImageAssetUrl; } });
Object.defineProperty(exports, "getFontAssetUrl", { enumerable: true, get: function () { return bui_assets_core_1.getFontAssetUrl; } });
